<!-- SocialLogin.vue -->
<template>
  <div
    v-if="loader"
    class="fixed inset-0 flex items-center justify-center bg-white z-50"
  >
    <img
      src="@/assets/imgs/tuin_loader_v2.gif"
      alt="cargando..."
      class="w-[500px]"
    >
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import axios from 'axios'

  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const loader = ref(true) // Definiendo la variable loader como true inicialmente
  const tokenSocial = ref(route.params.token)

  onMounted(async () => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/getProfileBySocialToken/${tokenSocial.value}`);
      const userData = response.data.resp; // Aquí tienes todo el objeto
      const userInfo = userData.info;
      const accessToken = userInfo.token_api;

      if (!accessToken) {
        console.error("No se recibió token_api");
        loader.value = false; // Ocultar loader en caso de error
        return;
      }

      // Armar correctamente el objeto que espera saveUserSession
      const sessionData = {
        id: userInfo.id,
        name: userInfo.full_name,
        email: userInfo.email,
        company_id: userInfo.company_id,
        step: userInfo.step,
        rols: (userInfo.roles || []).map(role => ({
          rol_name: role.rol_name || '',
          id: role.id || ''
        })),
        token_api: userInfo.token_api
      };

      // Guardar bien la sesión
      store.dispatch("saveUserSession", sessionData);

      // Redirigir según el valor del step
      switch (userInfo.step) {
        case 0:
          router.push({ name: "step1" });
          break;
        case 1:
          router.push({ name: "step2" });
          break;
        case 3:
          window.location.href = "/properties";
          break;
        default:
          console.warn("Step desconocido, redirigiendo a /");
          router.push("/");
          break;
      }

    } catch (error) {
      console.error("Error al obtener el perfil:", error);
      loader.value = false; // Ocultar loader en caso de error
      // Aquí podrías redirigir a login si quieres
    }
  })
</script>